module.exports = __webpack_public_path__ + "static/full-day-section-bubble-1-eb0dd75ddbd6b7632c103a07b66aa753.png";